import { Switch, TextInput } from "@mantine/core";
import { IconPencil, IconTrash } from "@tabler/icons";
import ActionCellRender from "../../components/actionCellRender";
import RemoteSelect2 from "../../components/remoteSelect2";
import {
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
  PageList,
} from "../../components/pageList";
import { useCellRender } from "../../hooks/useCellRender";

const apiEntity = "department";

const formSchema = {
  title: "Department",
  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
    size: "md",
  },
  apiEntity,
  initialValues: {
    code: "",
    name: "",
    active: true,
    heads: [],
  },
  validate: {
    code: (value) => (!value ? "Enter a code" : null),
    name: (value) => (!value ? "Enter a name" : null),
  },
  layout: {
    containers: [
      {
        key: "main",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.BOX,
        props: {},
      },
    ],
    fields: [
      {
        name: "code",
        component: TextInput,
        parent: "main",
        props: { label: "Code", required: true },
      },
      {
        name: "name",
        component: TextInput,
        parent: "main",
        props: { label: "Name", required: true },
      },
      {
        name: "heads",
        component: RemoteSelect2,
        parent: "main",
        props: {
          label: "Department heads",
          apiEntity: "user",
          labelField: "name",
          searchFields: ["name", "staffId", "cname", "email"],
          multiple: true,
          mt: "md",
          placeholder: "Search users",
        },
      },
      {
        name: "active",
        component: Switch,
        parent: "main",
        props: { label: "Active", mt: "md" },
      },
    ],
  },
};

const DepartmentPage = () => {
  const [cellRender] = useCellRender();

  const tableSchema = {
    showActionColumn: true,
    searchableFields: ["code", "name"],
    columns: [
      { field: "code", headerName: "Code" },
      { field: "name", headerName: "Name" },
      {
        field: "heads",
        headerName: "Heads",
        width: 280,
        cellRender: (col, data) => {
          const heads = Array.isArray(data.heads) ? data.heads : [];
          if (!heads.length) return "-";
          return cellRender.Users(heads);
        },
      },
      {
        field: "active",
        headerName: "Active",
        cellRender: (col, data) => (data.active === false ? "No" : "Yes"),
      },
      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [{ name: "edit", icon: IconPencil, props: {} }],
        actionMenu: [
          {
            name: "delete",
            label: "Delete data",
            icon: IconTrash,
            props: { color: "red" },
          },
        ],
      },
    ],
  };

  return (
    <PageList
      title="Departments"
      apiEntity={apiEntity}
      tableSchema={tableSchema}
      formSchema={formSchema}
    />
  );
};

export default DepartmentPage;
